import React from 'react'

const NotFoundScreen = () => {
  return (
    <div className='box'>NotFoundScreen</div>
  )
}

export default NotFoundScreen
